import React, { useState, useEffect } from 'react'
import { Panel, Row, Checkbox } from 'rsuite'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import ReactQuillFrom from '../../components/forms/input/ReactQuill/ReactQuillFrom'

export default function ContractCenterCommentForm({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  getValues,
}) {
  const [schema, setSchema] = useState(_schema)
  const [checkApprove, setCheckApprove] = useState(false)
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    setSchema(_schema)

    setCheckApprove(_schema?.contratCenterApprove?.value)
  }, [_schema])

  return (
    <>
      <Panel>
        {schema?.editorData && (
          // <Row style={{ marginTop: 10 }}>
          <ReactQuillFrom
            schema={schema?.editorData}
            toolbar={[]}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
            toolbars={[
              ['bold', 'italic', 'underline'],
              //[{ indent: '-1' }, { indent: '+1' },{ align: [] }],
              ['image'],
            ]}
          />
          // </Row>
        )}
        {schema?.contratCenterApprove && (
          <Row style={{ marginTop: 10 }}>
            <Controller
              key={schema?.contratCenterApprove?.name}
              name={schema?.contratCenterApprove?.name}
              control={control}
              defaultValue={checkApprove}
              render={(props) => {
                return (
                  <Checkbox
                    onChange={(value, checked) => {
                      props.onChange(checked)
                      setCheckApprove(checked)
                    }}
                    checked={checkApprove}
                  >
                    <p>{schema?.contratCenterApprove?.label}</p>
                  </Checkbox>
                )
              }}
            />
          </Row>
        )}
      </Panel>
    </>
  )
}
